{
  "processing": "جاري معالجة التحقق...",
  "loadingIframe": "جاري تحميل التحقق من الهوية...",
  "issueTitle": "مشكلة في التحقق من الهوية",
  "notConfigured": "لم يتم تكوين التحقق من الهوية بشكل صحيح لهذا المستودع.",
  "notSuccessful": "لم ينجح التحقق من الهوية. يرجى المحاولة مرة أخرى أو التواصل مع المستودع.",
  "couldNotCompleteProceed": "تعذر إتمام التحقق من الهوية، لكن يمكنك المتابعة بتسجيل الوصول.",
  "processFailed": "فشلت معالجة التحقق من الهوية. يرجى المحاولة مرة أخرى.",
  "processingFailedProceed": "فشلت معالجة التحقق من الهوية، لكن يمكنك المتابعة بتسجيل الوصول.",
  "genericError": "حدث خطأ أثناء التحقق من الهوية. يرجى المحاولة مرة أخرى.",
  "issueProceed": "واجه التحقق من الهوية مشكلة، لكن يمكنك المتابعة بتسجيل الوصول.",
  "requiredTryAgain": "التحقق من الهوية مطلوب لإتمام تسجيل الوصول. يرجى المحاولة مرة أخرى.",
  "checkInFailedTitle": "تعذّر تسجيل الوصول",
  "checkInFailedMessage": "تعذّر التحقق من هويتك"
}
